<template>
	<div>
		<h1>
			{{ $t('sections') }}
		<button @click="addNew" class="btn btn-primary ml-3 float-right">
			{{ $t('new-section') }}
		</button>
		</h1>

        <InfiniteScroll
			scrollElementId="main"
			type="Table"
			:cols="[{ key: 'name', heading: $t('name'), size: 12 }]"
			breakpoint="sm"
			:dataUrl="dataUrl"
			dataProperty="results"
			class="list-group border-radius-2 no-border"
			itemClass="list-group-item"
			@selectItem="selectItem"
			@deleteItem="deleteItem"
			ref="infinitescroll"
			:noResultsText="$t('no-results')"
			idProperty="id"
		/>

	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll"
export default {
	components: {
		InfiniteScroll
	},
	data() {
		return {
			dataUrl: `${this.$settings.APIBaseURL}/procedures/sections`
		}
	},
	mounted() {
		this.getItems();
	},
	methods: {
		selectItem(item) {
			this.$router.push(`/settings/interfaceeditor/sections/edit/${item.id}`);
		},
		deleteItem(item){
			this.$cfetch(`${this.$settings.APIBaseURL}/procedures/deletesection`, {
				data: {
					id: item.id
				}
			})
			.then((json) => {
				if (json.status.toLowerCase() === "success") {
					this.$refs.infinitescroll.removeItem(item);
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		getItems() {
			let body = {
				filters: {
				}
			};
			this.$refs.infinitescroll.getData("replace", body);
		},
		addNew() {
			this.$router.push(`/settings/interfaceeditor/sections/edit`);
		}
	},
	computed: {

	}
};
</script>
